import type { Command } from '../../types/commands'
import { addSessionFile, sessionNodeExists } from '../sessionFilesystem'
import { getContextDefaults } from '../../utils/contextUtils'

export const touchCommand: Command = {
  name: 'touch',
  description: 'Create an empty file or update timestamp',
  usage: 'touch <filename>',
  category: 'system',
  acceptsFiles: true,
  acceptsDirectories: false,
  execute: (args, context) => {
    if (args.length === 0) {
      return [
        {
          type: 'error',
          content: 'touch: missing file operand\nUsage: touch <filename>',
        },
      ]
    }

    const filename = args[0]
    const { currentDirectory, sessionFs } = getContextDefaults(context)

    // Validate filename
    if (filename.includes('/')) {
      return [
        {
          type: 'error',
          content: `touch: cannot create '${filename}': Paths not supported (use simple filenames)`,
        },
      ]
    }

    if (filename.startsWith('.') && filename.length > 1) {
      return [
        {
          type: 'error',
          content: `touch: cannot create '${filename}': Hidden files not allowed`,
        },
      ]
    }

    // Check if it's a directory
    const fullPath = currentDirectory === '~' ? filename : `${currentDirectory}/${filename}`
    const existingNode = sessionNodeExists(sessionFs, fullPath)

    if (existingNode) {
      // File exists, update timestamp
      const newFs = addSessionFile(sessionFs, currentDirectory, filename)
      context?.setSessionFilesystem(newFs)
      return [
        {
          type: 'success',
          content: `Updated timestamp: ${filename}`,
        },
      ]
    }

    // Create new file
    const newFs = addSessionFile(sessionFs, currentDirectory, filename, '')
    context?.setSessionFilesystem(newFs)

    return [
      {
        type: 'success',
        content: `Created file: ${filename}`,
      },
    ]
  },
}
